import React from "react";
import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import { envConfig } from "../constants";

// Initialize PostHog
if (typeof window !== "undefined" && envConfig.POSTHOG_KEY) {
  posthog.init(envConfig.POSTHOG_KEY, {
    api_host: envConfig.POSTHOG_HOST,
    // Disable debug mode to reduce console noise
    // loaded: (posthog) => {
    //   if (process.env.NODE_ENV === "development") posthog.debug();
    // },
    autocapture: true,
    capture_pageview: false,
    capture_pageleave: false,
    // Enable automatic error tracking
    capture_exceptions: true,
    // Enable session recording
    disable_session_recording: false,
    // Automatically add session headers to Express backend requests
    // __add_tracing_headers: [new URL(envConfig.EXPRESS_BACKEND_URL).host],
  });
}

interface PostHogProviderProps {
  children: React.ReactNode;
}

export const PostHogProvider: React.FC<PostHogProviderProps> = ({
  children,
}) => {
  return <PHProvider client={posthog}>{children}</PHProvider>;
};
